import React, { useState } from 'react';
import uploadViaPresign from '../script/uploadViaPresignV2';
import '../style/AddImages.css';

const AddImages = ({ setCafeImg, cafeImg }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploading,     setUploading]     = useState(false);
  const [uploadingIdx,  setUploadingIdx]  = useState(null);

  const uploadFile = (file) => uploadViaPresign(file, 'restaurant');

  const handleUpload = async () => {
    if (!selectedFiles.length) return;

    setUploading(true);
    const newUrls = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      setUploadingIdx(i + 1);
      try {
        const url = await uploadFile(selectedFiles[i]);
        newUrls.push(url);
      } catch {
        // skip failed file, continue with rest
      }
    }

    // Safely merge with existing — guard against non-array cafeImg
    const existing = Array.isArray(cafeImg) ? cafeImg : [];
    setCafeImg([...existing, ...newUrls]);

    setUploading(false);
    setUploadingIdx(null);
    setSelectedFiles([]);

    const input = document.getElementById('add-images-input');
    if (input) input.value = '';
  };

  const handleRemove = (index) => {
    const existing = Array.isArray(cafeImg) ? cafeImg : [];
    setCafeImg(existing.filter((_, i) => i !== index));
  };

  const handleFileChange = (e) => {
    setSelectedFiles(Array.from(e.target.files));
  };

  const uploaded = Array.isArray(cafeImg) ? cafeImg : [];

  return (
    <div className="add-images-wrap">

      <div className="add-images-row">
        <label className="add-images-label" htmlFor="add-images-input">
          Choose Images
        </label>
        <input
          id="add-images-input"
          className="add-images-input"
          type="file"
          accept="image/jpeg,image/png,image/webp,image/heic"
          multiple
          onChange={handleFileChange}
        />

        {selectedFiles.length > 0 && (
          <span className="add-images-count">
            {selectedFiles.length} file{selectedFiles.length > 1 ? 's' : ''} selected
          </span>
        )}

        <button
          className="add-images-btn"
          onClick={handleUpload}
          disabled={uploading || !selectedFiles.length}
        >
          {uploading
            ? `Uploading ${uploadingIdx} of ${selectedFiles.length}…`
            : 'Upload'}
        </button>
      </div>

      {uploaded.length > 0 ? (
        <div className="add-images-grid">
          {uploaded.map((url, index) => (
            <div className="add-images-thumb" key={url}>
              <img src={url} alt={`Image ${index + 1}`} />
              <button
                className="add-images-remove"
                onClick={() => handleRemove(index)}
                title="Remove"
              >
                x
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="add-images-empty">No images uploaded yet.</p>
      )}

    </div>
  );
};

export default AddImages;